export const SET_90S_MODE = "SET_90S_MODE";
export const SET_LIGHT_MODE = "SET_LIGHT_MODE";
export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_NEWS = "SET_NEWS;";
